import { render } from "./ModalNuovoRimborso.vue?vue&type=template&id=0225ab90&scoped=true"
import script from "./ModalNuovoRimborso.vue?vue&type=script&lang=js"
export * from "./ModalNuovoRimborso.vue?vue&type=script&lang=js"

import "./ModalNuovoRimborso.vue?vue&type=style&index=0&id=0225ab90&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0225ab90"]])

export default __exports__